const translations = {
  Upload: "Hochladen",
  "Select Header": "Kopfzeile auswählen",
  "Map Columns": "Spalten zuordnen",
  "Expected Column": "Erwartete Spalten",
  Required: "Erforderlich",
  "Drop your file here": "Datei hier ablegen",
  or: "oder",
  "Browse files": "Dateien durchsuchen",
  "Download Template": "Vorlage herunterladen",
  "Only CSV, TSV, XLS, and XLSX files can be uploaded": "Nur CSV-, TSV-, XLS- und XLSX-Dateien können hochgeladen werden",
  "Select Header Row": "Kopfzeilenreihe auswählen",
  "Select the row which contains the column headers": "Wähle die Zeile, die die Spaltenüberschriften enthält",
  "Only the first sheet (&quot;{{sheet}}&quot;) of the Excel file will be imported. To import multiple sheets, please upload each sheet individually.": "Nur das erste Blatt (&quot;{{sheet}}&quot;) der Excel-Datei wird importiert. Um mehrere Blätter zu importieren, lade bitte jedes Blatt einzeln hoch.",
  "Cancel": "Abbrechen",
  "Continue": "Weiter",
  "Your File Column": "Deine Spalte der Datei",
  "Your Sample Data": "Deine Beispieldaten",
  "Destination Column": "Zielspalte",
  "Include": "Einfügen",
  "Submit": "Senden",
  "Loading...": "Laden...",
  "Please include all required columns": "Bitte alle erforderlichen Spalten einfügen",
  "Back": "Zurück",
  "- Select one -": "- Wähle eine aus -",
  "- empty -": "- leer -",
  "Import Successful": "Import erfolgreich",
  "Upload Successful": "Upload erfolgreich",
  "Done": "Fertig",
  "Upload another file": "Eine weitere Datei hochladen",
};

export default translations;
